export const SPRING_PROPS = Object.freeze({
    default: {
        scale: 1
    },
    active: {
        scale: 0.9
    }
});
